import type {
  PaymentRepository,
  SessionClient,
  SyncSessionUC,
  User,
  UserRepository,
} from "@phurshell/psiapp-frontend-core/domain";

export class SyncSession implements SyncSessionUC {
  constructor(
    private readonly sessionClient: SessionClient,
    private readonly userRepo: UserRepository,
    private readonly paymentRepo: PaymentRepository,
  ) {}

  execute = async (): Promise<User | null> => {
    const session = this.sessionClient.getSession();
    if (!session) return null;

    const cards = await this.paymentRepo.getCreditCards();
    const favorite_card = await this.paymentRepo.getFavoriteCard(
      cards,
      session.favorite_card?.card_id,
    );
    const user = await this.userRepo.getUserById(session.id);
    this.sessionClient.updateSession({ ...user, favorite_card });
    return user;
  };
}
